<template>
    <div>
        <sav-template :title="$t('mot_de_passe_oublie.mot_de_passe_oublie')">
            <div class="p-6 my-4 bg-white border border-gray-200 shadow my-rounded">
                <h2 class="text-xl font-bold">{{ $tt('Mot de passe oublié') }}</h2>
                <span class="text-sm font-light">{{$t('mot_de_passe_oublie.reinitialiser_le_mot_de_passe')}}</span>
                <hr class="my-3">
                <sav-input :label="$tt('Adresse email')" type="email" v-model="email" :errors="errors" />
                <button test-id="btn-submit" :class="$styleTool.isLight($styleTool.cssConf('defaultBgColor')) ? 'text-black' : 'text-white'" class="px-3 py-2 my-3 text-sm font-light duration-100 shadow default-bg-color default-bg-color-hover:hover rounded-xl" :disabled="loading" @click="verifyEmail">
                    <i class="mr-2 fas fa-user-check"></i> {{$t('mot_de_passe_oublie.verifier_mon_compte')}}
                </button>
            </div>
        </sav-template>
    </div>
</template>

<script>
import apiService from '@/services/api.service'
export default {
    data() {
        return {
            loading: false,
            email: null,
            errors: []
        }
    },
    methods: {
        async verifyEmail() {
            this.errors = []
            if (this.email) {
                this.loading = true
                let response = await apiService.post('forgotpwd', {
                    mail: this.email
                })
                this.loading = false
                if (response.data.posts.error) {
                    this.errors.push(this.$t('mot_de_passe_oublie.adresse_email_introuvable'))
                } else {
                    this.email = null
                    this.$toast.success(this.$t('mot_de_passe_oublie.email_de_verification_envoye'))
                    this.$router.push({name: 'user.login'})
                }
            } else {
                this.errors.push(this.$t('mot_de_passe_oublie.adresse_email_obligatoire'))
            }
        }
    },
    mounted() {
    },
}
</script>



// WEBPACK FOOTER //
// src/companies/default/views/user/ForgotPassword.vue